
import "/root/workspace/crm-pc_pGKl/src/components/RightContent/index.less?modules";
export default {"account": `account-9FKKdVDo`,"search": `search-ynG0pjo2`,"avatar": `avatar-Pu3nLm_L`,"dark": `dark-DLfrPOgY`,"menu": `menu-I_7Iu_fu`,"right": `right-sT_Scpv9`,"action": `action-INd3Lu7b`,"name": `name-cJ6HzNBK`}
